// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-btn.is-expanded .v-icon {\n  transform: rotate(-180deg);\n}\n.v-icon.spin-btn {\n  transition-duration: 1s;\n}\n.v-icon.spin-btn:hover {\n  transform: rotate(-180deg);\n  color: #F9A825;\n}", ""]);
// Exports
module.exports = exports;
